var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccountSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00a0df;}.cls-3{fill:#0072b2;}.cls-4{fill:#ffaed9;}.cls-5{fill:#fffbc5;}.cls-6{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.13,
    y: 0.75,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "subscription"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.31,
    y: 118.68,
    width: 598.48,
    height: 363.52,
    rx: 18.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 181.97,
    width: 600,
    height: 83.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 88.96,
    cy: 395.32,
    r: 41.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 262.74,
    cy: 395.32,
    r: 41.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 148.47,
    cy: 395.32,
    r: 41.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountSubscription);
export default __webpack_public_path__ + "static/media/user_account_subscription.ebe127dd3b120b883f2bba24e8d4dfbd.svg";
export { ForwardRef as ReactComponent };